module.exports = __webpack_public_path__ + "static/media/specs-off.957f44e5.svg";